import { render, staticRenderFns } from "./BModalForm.vue?vue&type=template&id=1a5154a6"
import script from "./BModalForm.vue?vue&type=script&lang=js"
export * from "./BModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports